(() => {
  const node = document.getElementById('raLocalizationData');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  let manualChanged = false;
  const manualKey = 'ra-localization-choice';
  const sessionKey = 'ra-localization-checked';
  const read = (storage, key) => { try { return JSON.parse(storage.getItem(key)); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, JSON.stringify(value)); } catch {} };
  const enabled = document.querySelector('.ra-localization-form');
  const returnPath = () => location.pathname + location.search + location.hash;
  const prepare = form => {
    let input = form.querySelector('[name="return_to"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'return_to'; form.append(input); }
    input.value = returnPath();
  };
  document.addEventListener('change', event => {
    const form = event.target.closest('.ra-localization-form');
    if (!form || !['country_code', 'language_code'].includes(event.target.name)) return;
    manualChanged = true;
    const value = Object.fromEntries(new FormData(form));
    write(localStorage, manualKey, {country: value.country_code, language: value.language_code});
    write(sessionStorage, sessionKey, true);
    prepare(form);
    form.requestSubmit();
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('.ra-localization-form');
    if (!form) return;
    prepare(form);
    write(sessionStorage, sessionKey, true);
  });
  const submit = (country, language) => {
    if (country === config.country && language === config.language) return;
    const form = document.createElement('form');
    form.action = config.action || enabled?.action || '/localization'; form.method = 'post'; form.hidden = true;
    for (const [name, value] of Object.entries({_method: 'put', form_type: 'localization', country_code: country, language_code: language, return_to: returnPath()})) {
      const input = document.createElement('input'); input.name = name; input.value = value; form.append(input);
    }
    document.body.append(form); form.submit();
  };
  const euCountries = new Set(['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE']);
  const euDomain = /\.(at|be|bg|hr|cy|cz|dk|ee|fi|fr|de|gr|hu|ie|it|lv|lt|lu|mt|nl|pl|pt|ro|sk|si|es|se|eu)$/.test(location.hostname);
  const hasExplicitLocale = config.root.replace(/\/$/, '') !== '';
  const run = async () => {
    if (!config.automatic || config.designMode || hasExplicitLocale || read(sessionStorage, sessionKey)) return;
    write(sessionStorage, sessionKey, true);
    const saved = read(localStorage, manualKey);
    if (saved && config.countries.includes(saved.country) && config.languages.includes(saved.language)) { submit(saved.country, saved.language); return; }
    try {
      const params = new URLSearchParams({'country[enabled]': 'true', 'country[exclude]': config.country, 'language[enabled]': 'true', 'language[exclude]': config.language});
      const response = await fetch(config.root + 'browsing_context_suggestions.json?' + params, {headers: {Accept: 'application/json'}, signal: AbortSignal.timeout(4000)});
      if (!response.ok) return;
      const result = await response.json();
      if (manualChanged) return;
      const parts = result.suggestions?.[0]?.parts || {};
      let country = parts.country?.handle || config.country;
      let language = parts.language?.handle || config.language;
      if (!config.countries.includes(country)) country = config.country;
      if (!config.languages.includes(language)) language = config.language;
      if (euDomain && euCountries.has(result.detected_values?.country?.handle || country)) country = config.country;
      if (parts.country?.confidence !== undefined && parts.country.confidence < 0.9) country = config.country;
      if (parts.language?.confidence !== undefined && parts.language.confidence < 0.9) language = config.language;
      submit(country, language);
    } catch {}
  };
  run();
})();
